import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight, faCheck } from '@fortawesome/free-solid-svg-icons';
import { Button } from 'reactstrap';
import "../../assets/css/stepper.css"
export default function Stepper({ steps = [], activeStep = 1, setActiveStep, children, onSubmit }) {

    //Função que passa para o proximo passo
    const nextStep = () => {
        const errors = steps[activeStep - 1].validateStep ? steps[activeStep - 1].validateStep() : false;
        if (!errors || errors.length == 0) {
            if (activeStep >= steps.length && onSubmit) {
                onSubmit();
            }
            setActiveStep(activeStep >= steps.length ? activeStep : activeStep + 1);
        }
    };

    //Função que passa para o passo anterior
    const previousStep = () => setActiveStep(activeStep >= 2 ? activeStep - 1 : activeStep);

    return (
        <div className="stepper" id="stepper2">
            <div className="steps-container">
                <div className="steps d-flex align-items-center justify-content-around justify-content-lg-between">
                    {steps && steps.map((value, key) => {
                        const activeGradient = `${activeStep >= key + 1 ? "bg-success" : "bg-secondary"}`
                        const activeGradientLongBar = `${activeStep > key + 1 ? "bg-success" : "bg-secondary"}`
                        return (
                            <div key={key} className={`mx-2 step d-none ${key + 1 === activeStep ? 'activeStep1' : key + 1 === activeStep + 1 ? "activeStep2" : ""} d-lg-block`} icon="fa fa-pencil-alt" id="1">
                                <div className="mt-2 step-title d-flex align-items-start justify-content-start " style={{ position: "relative" }}>
                                    <div className='d-flex align-items-center justify-content-center flex-column' style={{ zIndex: 2 }}>
                                        <span className={`d-flex align-items-center justify-content-center bg-gradient display-6 ${activeGradient}`} style={{ color: "#fff", borderRadius: "100%", width: "70px", height: "70px", position: "relative" }}>
                                            {key + 1}

                                            {key != steps.length - 1 &&
                                                <div style={{ height: "70px", left: "60px", position: "absolute", zIndex: "-1" }} className='d-flex align-items-center justify-content-center'>
                                                    <div style={{ width: `${35 / steps.length}vw`, height: "15px", borderRadius: "50px" }} className={` bg-gradient ${activeGradientLongBar}`}></div>
                                                </div>
                                            }
                                        </span>
                                        <div className={`step-text d-flex flex-column ${activeStep == key + 1 ? "" : "invisible"}`}>{value.text}{value.optional ? <span style={{ fontSize: "9pt" }}>(Opcional)</span> : <></>}</div>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
            <div className="stepper-content-container">
                <div className="mt-4 d-flex align-items-center justify-content-between">
                    <h4 className=' m-3 fw-normal'>{steps[activeStep - 1].text}</h4>
                    {steps[activeStep - 1].btnAdicionar ?
                        <Button color='success' className='me-4 bg-gradient d-flex align-items-center' onClick={steps[activeStep - 1].btnAdicionar}>
                            {steps[activeStep - 1].btnAdicionarText ? steps[activeStep - 1].btnAdicionarText : "+ Adicionar"}
                        </Button>
                        : <></>}
                </div>

                {children}
                
                <div className='d-flex align-items-center justify-content-center'>
                    {activeStep !== 1
                        ?
                        <Button outline color='secondary' className='me-4  bg-gradient d-flex align-items-center' onClick={previousStep}><FontAwesomeIcon icon={faArrowLeft} className={"me-3"} /> Anterior</Button>
                        :
                        <></>
                    }
                    <Button color='success' className='bg-gradient d-flex align-items-center' onClick={nextStep}> {activeStep === steps.length ? <FontAwesomeIcon icon={faCheck} className={"me-3"} /> : <></>} {activeStep === steps.length ? "Concluir" : `Próximo`} {activeStep === steps.length ? <></> : <FontAwesomeIcon icon={faArrowRight} className={"ms-3"} />}</Button>
                </div>
            </div>
        </div>
    )
}